module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description","usageGuidance":"Usage guidance","unit":"Unit","formula":"Formula"},"de":{"description":"Beschreibung","usageGuidance":"Anleitung","unit":"Einheit","formula":"Formel"}}')
  delete Component.options._Ctor
}
